module.exports = __webpack_public_path__ + "img/亲情钻石.eb27d83b.png";